import { render, staticRenderFns } from "./TransactionSummary.vue?vue&type=template&id=26bc83e1&"
import script from "./TransactionSummary.vue?vue&type=script&lang=js&"
export * from "./TransactionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports